import styled from 'styled-components';

export const StripeContainer = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 0.875rem;
  margin-bottom: 2rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 4px 24px;
  position: relative;

  h3 {
    margin-bottom: 0;
    font-size: 1rem;
    text-transform: uppercase;
  }
`;

export const StripeHeader = styled.h3`
  font-size: 1.5rem;
  font-weight: 400;
`;
